import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Coupon } from 'src/app/core/interfaces/coupon';
import { HttpRequestService } from 'src/app/core/services';
import { format } from 'date-fns';
import { ExcelService } from 'src/app/core/services/excel.service';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-coupon-details',
  templateUrl: './coupon-details.component.html',
  styleUrls: ['./coupon-details.component.scss'],
})
export class CouponDetailsComponent implements OnInit {
  couponData: any[] = [];
  idForUpdate: string = '';
  couponName: string = '';
  useCount: number = 0;
  totalCount: number = 0;
  pageSize = 10;
  pageIndex = 1;
  loading = false;
  skipIndex = 0;
  index: number = 0;

  allCoupons: Coupon[] = [];
  allApprovedCoupons: Coupon[] = [];
  isAddOrUpdate: boolean = true;
  totalDataCount = 0;
  totalApprovedDataCount = 0;
  search = '';
  userRole: string = '';
  subAdminAddedCoupon: Coupon[] = [];
  startDate: any;
  endDate: any;
  dateRange: any;
  snapShootIndex: number = 0;
  predefinedColors: string[] = ['magenta', 'blue', 'green', 'red', 'purple'];

  constructor(
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private excelService: ExcelService
  ) {
    this.idForUpdate = this.activatedRoute.snapshot.params.id;
  }

  ngOnInit(): void {
    // this.getCouponById();
  }
  getCouponData(index: number = 0, skip = 0, sortBy?: any): void {
    let params: any;
    params = { skip: this.skipIndex, limit: this.pageSize };
    if (this.idForUpdate) {
      params.couponId = this.idForUpdate;
    } else {
      delete params.couponId;
    }
    if (this.startDate && this.endDate) {
      params.startDate = this.startDate;
      params.endDate = this.endDate;
    } else {
      delete params.startDate;
      delete params.endDate;
    }
    this.loading = true;
    this.httpRequestService
      .request('get', 'coupon-codes/analytics', params)
      .subscribe(
        (result: any) => {
          this.loading = false;
          console.log(result);
          this.couponData = result.data;
          this.couponName = result.meta.couponName;
          this.totalCount = result.totalCount;
          this.useCount = result.meta.usedCouponCount;
        },
        (error: any) => {
          this.loading = false;
          console.log(error);
          this.notificationService.error(
            'Error',
            'Something went wrong while fetching coupon data'
          );
        }
      );
  }

  goBack() {
    window.history.back();
  }

  get couponTotalAmount(): number {
    return this.couponData.reduce(
      (acc, item) => acc + (item.totalAmount || 0),
      0
    );
  }

  onChangeDateRange(date: any) {
    this.startDate = format(date[0], 'yyyy-MM-dd');
    this.endDate = format(date[1], 'yyyy-MM-dd');
    this.getCouponData(this.index);
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.couponData = [];
    const { pageSize, pageIndex } = params;
    this.skipIndex = pageSize * (pageIndex - 1);
    this.getCouponData(this.index, pageSize * (pageIndex - 1));
  }

  downloadCouponExcel() {
    let params: any = {};
    console.log(this.idForUpdate);
    if (this.idForUpdate) {
      params.couponId = this.idForUpdate;
    } else {
      delete params.couponId;
    }
    if (this.startDate && this.endDate) {
      params.startDate = this.startDate;
      params.endDate = this.endDate;
    } else {
      delete params.startDate;
      delete params.endDate;
    }
    const apiUrl = `${environment.apiBaseUrl}/api/coupon-codes/download-excel`;
    this.excelService.downloadCouponDataExcel(apiUrl, 'data.xlsx', params);
  }
}
